let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l69GS")).then(() => parcelRequire('gqwzE'));